import React from "react";
import "./Title.css";

export default function Title({ title }) {
  return <header className="Title">{title}</header>;
}
